import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import GameBoard from './components/GameBoard';

function App() {
  return (
    <div className="App">
      <GameBoard />
    </div>
  );
}

export default App;
